import {
  Box,
  Flex,
  Icon,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Icons } from "../../WinterCountIconFIle";

const RecentlyMergedTable = ({
  data,
  isLoading,
  fetchMoreMerges,
  errorMerges,
}) => {
  const navigate = useNavigate();

  return (
    <Box>
      <TableContainer maxH="55vh" overflowY="auto">
        <Table size="sm" variant="striped">
          <Thead>
            <Tr>
              {["First Name", "Last Name", "Open"].map((label) => (
                <Th
                  key={label}
                  position="sticky"
                  top={0}
                  bg="white"
                  zIndex={1}
                  py={3}
                  px={5}
                  fontSize="xs"
                  fontWeight="600"
                  letterSpacing="0.06em"
                  textTransform="uppercase"
                  color="gray.400"
                  borderBottomWidth="1px"
                  borderColor="gray.100"
                >
                  {label}
                </Th>
              ))}
            </Tr>
          </Thead>

          <Tbody>
            {isLoading &&
              Array.from({ length: 6 }).map((_, idx) => (
                <Tr key={idx}>
                  {Array.from({ length: 3 }).map((_, i) => (
                    <Td key={i} px={5} py={3}>
                      <Skeleton height="14px" borderRadius="md" />
                    </Td>
                  ))}
                </Tr>
              ))}

            {!isLoading &&
              data?.length > 0 &&
              data.map((item, idx) => (
                <Tr
                  key={idx}
                  _hover={{ bg: "blue.100" }}
                  transition="background 0.15s ease"
                  borderBottomWidth="1px"
                  borderColor="gray.50"
                >
                  <Td px={5} py={3}>
                    <Text fontSize="sm" fontWeight="500" color="gray.700">
                      {item.FIRST_NAME}
                    </Text>
                  </Td>
                  <Td px={5} py={3}>
                    <Text fontSize="sm" color="gray.500">
                      {item.LAST_NAME}
                    </Text>
                  </Td>
                  <Td px={5} py={3} isNumeric>
                    <Icon
                      as={Icons.OpenExternalLinkIcon}
                      boxSize={4}
                      color="gray.400"
                      cursor="pointer"
                      _hover={{ color: "purple.500" }}
                      transition="color 0.15s"
                      onClick={() => navigate(`/personview/${item.id}`)}
                    />
                  </Td>
                </Tr>
              ))}

            {!isLoading && !data?.length && (
              <Tr>
                <Td colSpan={3} px={5} py={10} textAlign="center">
                  <Text fontSize="sm" color="gray.400">
                    No recently merged records
                  </Text>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </TableContainer>

      {errorMerges && (
        <Flex justify="center" py={4}>
          <Text fontSize="sm" color="red.400">
            Failed to load recently merged users
          </Text>
        </Flex>
      )}

      {/* <Box borderTopWidth="1px" borderColor="gray.100" px={5} py={3}>
        <Button
          onClick={fetchMoreMerges}
          isDisabled={isLoading}
          size="xs"
          w="100%"
          variant="ghost"
          color="gray.500"
          fontWeight="500"
          borderRadius="lg"
          _hover={{ bg: "gray.50", color: "gray.700" }}
        >
          Load more
        </Button>
      </Box> */}
    </Box>
  );
};

export default RecentlyMergedTable;
